import React from 'react';
type Variant = 'brand' | 'neutral';
type Size = 'md' | 'sm';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  icon?: React.ReactNode;
}
const variantClasses: Record<Variant, string> = {
  brand: 'border-sf-blue bg-sf-blue text-white hover:border-sf-blue-dark hover:bg-sf-blue-dark disabled:border-[#C9C9C9] disabled:bg-[#C9C9C9] disabled:text-white',
  neutral: 'border-sf-border-strong bg-white text-sf-blue hover:bg-sf-bg disabled:bg-white disabled:text-[#939393]'
};
const sizeClasses: Record<Size, string> = {
  md: 'h-8 px-4 text-[13px] [&_svg]:h-4 [&_svg]:w-4',
  sm: 'h-6 px-2.5 text-xs [&_svg]:h-3.5 [&_svg]:w-3.5'
};
export function Button({
  variant = 'neutral',
  size = 'md',
  icon,
  className = '',
  children,
  type = 'button',
  ...rest
}: ButtonProps) {
  return <button type={type} className={`inline-flex items-center justify-center gap-1.5 whitespace-nowrap rounded border font-medium transition-colors duration-150 ease-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sf-blue focus-visible:ring-offset-1 disabled:cursor-not-allowed ${variantClasses[variant]} ${sizeClasses[size]} ${className}`} {...rest} data-id="element-796" data-mp="13v05gutdgeh7">
      {icon && <span className="inline-flex" aria-hidden="true" data-id="element-797" data-mp="ga20sjji3zgv">
          {icon}
        </span>}
      {children}
    </button>;
}